import $ from 'jquery';

require('datatables.net');
require('datatables.net-colreorderwithresize-npm');
require('datatables.net-bs');
require('datatables.net-buttons');
require('datatables.mark.js');

/**
 * Parses the plain html table into a DataTables.js table, including sorting, column reordering and
 * column hiding functionality
 *
 * @param {string} tableId Id of the HTML table tag containing the data
 * @param {string} dragAndDropContainerId Id of the HTML container tag where the column headers can be dropped
 * @param {string} hiddenHeadersTableId Id of the HTML table tag that will hold all the hidden headers
 * @param {[{string, number}, ...]} colDefs Temporary parameter. MUST REFACTOR
 * @returns {DataTables API} DataTables.js handle for the created table
 */
export default function buildResizableDataTable(tableId,data, dragAndDropContainerId, hiddenHeadersTableId, colDefs, scrollX = true) {

    //TODO: Almacenar las configuraciones de la tabla en las preferencias del usuario
    if ($.fn.DataTable.isDataTable('#' + tableId)) {
        /*$(".dataTables_empty").remove();
        let table = $("#" + tableId).DataTable();
        $('#' + tableId + ' > tbody  > tr').each(function () {
            if (!$(this).is(':empty')) {
                //do something
                table.row.add($(this));
            }
        });
        table.draw();
        return $("#" + tableId).DataTable();*/
        let table = $("#" + tableId).DataTable();
        /*table.rows().invalidate();
        table.draw();*/
        return table;
    }

    $("#" + tableId + " thead tr").children('th').each(function (index) {
        // "this" is the current element in the loop
        this.setAttribute("colName", colDefs[index].name);
    });

    //--TABLE FOR HIDDEN HEADERS--
    let columnDrop = $('#' + dragAndDropContainerId);
    let hiddenColumns = $('#' + hiddenHeadersTableId);

    //Since the container might overflow we set the default mouse scroll to horizontal
    columnDrop.on("mousewheel", function (event, delta, deltaX, deltaY) {
        event.preventDefault();
        columnDrop.scrollLeft(columnDrop.scrollLeft() - deltaY * 30);
    });
    //The headers of the table are the same as the ones from the original table and the body is never displayed
    hiddenColumns.append($("#" + tableId + " thead ").clone(true, true));
    hiddenColumns.append('<tbody role="tablist" style="display: none;">' + '</tbody>');
    hiddenColumns.mousedown(function (ev) {
        ev.preventDefault();
    });

    //Datatables table handle
    let hiddenColumnsTable = hiddenColumns.DataTable({
        dom: 'Rlfrtip',
        paging: false,
        searching: false,
        ordering: false,
        info: false,
        columnDefs: colDefs,
        colReorder: true,
    });
    hiddenColumnsTable.columns().visible(false);

    //--DATABASE FILLED TABLE--

    let fixedColumnsRight = 1;
    let fixedColumnsLeft = 1;

    let table = $('#' + tableId).DataTable({
        /*dom: 'Rlfrtip',*/
        //data:data,
        scrollX: scrollX,
        paging: true,
        orderClasses: false,
        columnDefs: colDefs,
        deferRender: true,
        stripeClasses: [],
        colReorder: {
            colReorder: true,
            realtime: false,
            fixedColumnsLeft: fixedColumnsLeft,
            fixedColumnsRight: fixedColumnsRight
        },
        colResize: {
            isEnabled: true,
            saveState: true,
            hoverClass: 'dt-colresizable-hover',
            hasBoundCheck: true,
            minBoundClass: 'dt-colresizable-bound-min',
            maxBoundClass: 'dt-colresizable-bound-max',
        },
        order: [[1, 'asc']],
        mark: true,
        language: {
            "decimal": "",
            "emptyTable": "No hay información",
            "info": "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
            "infoEmpty": "Mostrando 0 a 0 de 0 Entradas",
            "infoFiltered": "(Filtrado de _MAX_ total entradas)",
            "infoPostFix": "",
            "thousands": ",",
            "lengthMenu": "Mostrar _MENU_ Entradas",
            "loadingRecords": "Cargando...",
            "processing": "Procesando...",
            "search": "Buscar:",
            "zeroRecords": "Sin resultados encontrados",
            "paginate": {
                "first": "Primero",
                "last": "Ultimo",
                "next": "Siguiente",
                "previous": "Anterior"
            }
        },
    });

    //--EVENT HANDLING FOR DRAG AND DROP AND VISIBILITY CHANGES--

    let ColumnType = {
        visible: "VISIBLE",
        hidden: "HIDDEN"
    }
    //table header
    let tableHeader = scrollX ? $('.dataTables_scrollHeadInner table thead') : $("#" + tableId + " thead ");
    //Clicked column header
    let th;
    //Map of column sizes. Necessary for hide/show logic
    let colSizes = {};
    //Auxiliary variable used to reset column order
    let order = [...Array(colDefs.length).keys()];
    let dragging = false;

    /**
     * Returns the name of the column header clicked when starting to drag
     * @param clickedElement Html element where the user clicked
     * @returns {string} Name of the data property contained in the column
     */
    function handleClick(clickedElement) {
        th = clickedElement.closest('th');
        return th.attr("colName");
    }

    /**
     * Changes a column header between tables based on where it is dragged onto
     * @param ev Event handler
     * @param colName Name of the dragged column
     * @param columnType Enum instance that indicates whether the column is from the data or hidden headers table
     */
    function handleDragging(ev, colName, columnType) {

        //The header is dragged out of the hidden headers table or
        //The header previously dragged out of the data table is put back (user changes its mind)
        if ((columnType === ColumnType.hidden && !isDraggingOver(columnDrop, ev)) ||
            (columnType === ColumnType.visible && isDraggingOver(tableHeader, ev))) {
            if (!table.column(colName + ":name").visible()) {
                //Make room for the new column
                tableSizeChange(colName, true);
                table.column(colName + ":name").visible(true);
                hiddenColumnsTable.column(colName + ":name").visible(false);
                // Force a width recalculation for Chrome compatibility
                hiddenColumns.css("width", "min-content");
            }
        }

            //The header previously dragged out of the data table is dragged onto the column drop container or
        //The header previously dragged out of the hidden headers table is put back (user changes its mind)
        else if (columnType === ColumnType.visible && isDraggingOver(columnDrop, ev) ||
            columnType === ColumnType.hidden && isDraggingOver(columnDrop, ev)) {
            if (table.column(colName + ":name").visible()) {
                //Reduce table size
                tableSizeChange(colName, false);
                table.column(colName + ":name").visible(false);
                hiddenColumnsTable.column(colName + ":name").visible(true);
            }
        }
        //Hide the columns position pointer when dragging out of the table
        if ((isDraggingOver(tableHeader, ev) && columnType === ColumnType.visible) ||
            (isDraggingOver(columnDrop, ev) && columnType === ColumnType.hidden)) {
            $(".DTCR_pointer").css("visibility", "visible");
        } else {
            $(".DTCR_pointer").css("visibility", "hidden");
        }
    }

    //--ADDING EVENT LISTENERS--


    tableHeader.on('mousedown.ColReorder touchstart.ColReorder', 'tr th', function (ev) {

        if (ev.button === 0) {
            dragging = true;
            let colName = handleClick($(this));
            if (table.columns().header().length - fixedColumnsRight <= table.column(colName + ":name").index() ||
                fixedColumnsRight > table.column(colName + ":name").index()) {
                $(this).css("cursor", "not-allowed");
                return;
            }
            //Use getBoundingClientRect to prevent constant up-rounding
            colSizes[colName] = Math.trunc(th[0].getBoundingClientRect().width);
            $(document).on('mousemove.ColReorder', function (ev) {
                handleDragging(ev, colName, ColumnType.visible);
            });
        }
    });

    /*tableHeader.on('mouseup.ColReorder touchend.ColReorder', 'tr th', function (ev) {
        $(this).css("cursor", "");
        dragging = false;
        console.log("not dragging");
    });*/

    $("#btnResetView").on("click", function () {
        table.colResize.reset();
        table.colReorder.order(order);
        table.columns().visible(true);
        hiddenColumnsTable.columns().visible(false);
    })

    table.on('column-reorder', function (e, settings, details) {
        for (let i = 0; i < details.mapping.length; i++) {
            order[i] = details.mapping[order[i]];
        }
    });

    hiddenColumns.on('mousedown.ColReorder touchstart.ColReorder', 'thead tr th', function (ev) {
        if (ev.button === 0) {
            dragging = true;
            let colName = handleClick($(this));
            $(document).on('mousemove.ColReorder', function (ev) {
                handleDragging(ev, colName, ColumnType.hidden);
            });
        }
    });

    $(document).on('mouseup', function () {
        dragging = false;
    });

    // Enable horizontal via mousewheel click and drag
    if (scrollX) {
        enableMousewheelDragScrolling($(".dataTables_scrollBody"));
    }

    // Add a message for the user in case a search action has been started while there are hidden columns

    $('<div>', {
        class: 'row m-b-10 m-r-10',
        style: 'display: none;',
        html: '<span> <i class="fas fa-info-circle badge-info"></i> El filtrado de filas por búsqueda también emplea los datos de columnas ocultas</span>'
    }).appendTo($("#" + tableId + "_filter"));

    $("#" + tableId + "_filter label input").on('input', function () {
        changeNoticeDisplay();
    });

    hiddenColumnsTable.on('column-visibility.dt', function () {
        changeNoticeDisplay();
    })

    function changeNoticeDisplay() {
        if (table.search() && hiddenColumnsTable.columns().visible().toArray().includes(true)) {
            $("#" + tableId + "_filter div:last").css("display", "block");
        } else {
            $("#" + tableId + "_filter div:last").css("display", "none");
        }
    }

    let lastCell;
    let lastWidth;

    function adjustHeaders(mutationRecords) {
        let redraw = false;
        let currentCell = $(mutationRecords[0].target).closest( "td" );
        if(lastCell?.get(0)?.cellIndex !== currentCell?.get(0)?.cellIndex){
            redraw = true;
        }
        if(lastWidth !== currentCell?.width()){
            redraw = true;
        }
        lastCell = currentCell;
        lastWidth = currentCell?.width();
        if (!dragging && redraw) {
            //table.columns.adjust().draw();
            observer.disconnect();
            //table.rows(currentCell).invalidate().draw();
            table.draw("page");
            observer?.observe(document.querySelector('table[id="'+tableId+'"]>tbody'), {childList: true, subtree: true, attributes: false, characterData: false});

        }
    }

    let observer = new MutationObserver(adjustHeaders);
    observer?.observe(document.querySelector('table[id="'+tableId+'"]>tbody'), {childList: true, subtree: true, attributes: false, characterData: false});



    /**
     * Changes the size of the table based on whether a column has been shown or hidden
     * @param colName Name of the column
     * @param state true if the column is now visible false if it is hidden
     */
    function tableSizeChange(colName, state) {
        if (scrollX) {
            let currWidth = tableHeader[0].getBoundingClientRect().width;
            let newWidth;
            if (state) {
                //Column is now visible, make room for it based on its previously saved width
                newWidth = currWidth + colSizes[colName];

            } else {
                //Column is now hidden, subtract its previously saved width from the table's width
                newWidth = currWidth - colSizes[colName];
            }
            //Include duplicate headers for scrollX compatibility
            $(".dataTables_scrollHeadInner").width(newWidth);
            $(".dataTables_scrollHeadInner table").width(newWidth);
            $(".dataTables_scrollBody table").width(newWidth);
        } else {
            $("#" + tableId + "").css("width", "100%");
        }
        /*if(!scrollX) {
            $("#"+tableId+"").css("width", "100%");
        }*/
    }

    return table;
}

/**
 * Checks whether an element is being dragged onto a container based on mouse position and screen dimensions
 * @param container JQuery handle, containing offset, height and width values
 * @param ev Event handler containing mouse data
 * @returns {boolean} true if the mouse is inside the container, false otherwise
 */
function isDraggingOver(container, ev) {
    let offset = container.offset();
    let posY = offset.top - $(window).scrollTop();
    let posX = offset.left - $(window).scrollLeft();
    let width = container.width();
    let height = container.height();

    return ev.clientX > posX && ev.clientX < posX + width &&
        ev.clientY > posY && ev.clientY < posY + height;
}

/**
 * Allows to scroll horizontally by clicking and dragging with the mousewheel
 * @param slider Jquery handle of the scrollable element
 */
function enableMousewheelDragScrolling(slider) {
    let mouseDown = false;
    let startX, scrollLeft;
    let startY, scrollTop;

    let startDragging = function (e) {
        if (e.button === 1) {
            e.preventDefault();
            mouseDown = true;
            startX = e.pageX - slider.offset().left;
            scrollLeft = slider.scrollLeft();
            startY = e.pageY - slider.offset().top;
            scrollTop = slider.scrollTop();
            slider.css("cursor", "move");
        }
    };
    let stopDragging = function () {
        mouseDown = false;
        slider.css("cursor", "");
    };

    slider.on('mousemove', (e) => {
        //e.preventDefault();
        if (!mouseDown) {
            return;
        }
        const x = e.pageX - slider.offset().left;
        const scrollX = x - startX;
        const y = e.pageY - slider.offset().top;
        const scrollY = y - startY;
        slider.scrollLeft(scrollLeft - scrollX);
        slider.scrollTop(scrollTop - scrollY);
    });

    // Add the event listeners
    slider.on('mousedown', startDragging);
    slider.on('mouseup', stopDragging);
    slider.on('mouseleave', stopDragging);
}
